import { knownFormFields } from "@/modules/crm/leads/constant";
import { getSocialMedias } from "@/store/slices/lead/leadSlice";

export const getSegments = (inputString, chunkSize = 160) => {
  if (inputString) {
    const regex = new RegExp(`[\\s\\S]{1,${chunkSize}}`, "g");
    const chunks = inputString.match(regex) || [];
    return chunks;
  } else return inputString;
};

export const getSegmentsLength = (text) => {
  let segments = getSegments(text) && getSegments(text).filter(Boolean);
  return segments.length || 0;
};

export const getNames = (value) => {
  return value?.map((item) => item.name);
};

export const convertMarkdownLinks = (markdown) => {
  const markdownRegex = /\[([^\]]+)\]\(([^)]+)\)/g;
  const html = markdown.replace(
    markdownRegex,
    '<a href="$2" target="_blank">$1</a>'
  );
  return html;
};

export const getLeadColumnsJSON = async () => {
  // append custom fields inside known form fields
  let combineData = JSON.parse(JSON.stringify(knownFormFields));
  combineData.sections[0].fields = combineData?.sections?.[0]?.fields.filter(
    (field) => field?.name !== "createdOn" && field?.name !== "modifiedOn"
  );
  let socialMedias = await getSocialMedias();
  if (!combineData?.sections?.find((s) => s.id == "socialMediaLinks")) {
    combineData.sections.splice(2, 0, socialMedias);
  }
  let tempData = [];
  combineData.sections.map((section) => tempData.push(...section.fields));

  // adding company name manually, not available in lead columns
  tempData.push({
    title: "Company Name",
    value: "",
    name: "companyName",
    type: "text",
    fieldHidden: true,
    customCode: { label: "[Lead CompanyName]", value: "ABC Company" },
  });
  return tempData;
};

export const getLeadHashList = (customCodes = []) => {
  // let columns = await getLeadColumnsJSON();
  let hashList = customCodes
    .map((col, index) => {
      if (col?.fullName) {
        let payload = { id: index + 1, value: col?.fullName };
        return payload;
      }
    })
    .filter(Boolean);
  return hashList;
};

export const getCustomCodesObject = async () => {
  let tempData = await getLeadColumnsJSON();
  let tempCustomCodes = tempData.reduce((prev, curr) => {
    if (curr?.customCode) {
      return Object.assign(prev, {
        [`#${curr?.customCode?.label}`]: curr?.customCode?.value,
      });
    } else {
      return prev;
    }
  }, {});
  return tempCustomCodes;
};

export const getParsedText = (text, mapText) => {
  if (text && mapText) {
    function findAndReplace(text, replacements) {
      // Create a regular expression that matches all substrings to be replaced
      const regex = new RegExp(
        Object.keys(replacements)
          .map((key) => escapeRegExp(key)) // Escape square brackets in the keys
          .join("|"),
        "g"
      );

      // Use the regular expression to replace all matches with their corresponding values
      const result = text.replace(regex, (match) => {
        console.log("match", match);
        return replacements[match];
      });

      return result;
    }

    // Function to escape square brackets in the keys
    function escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }

    const replacements = mapText;

    const replacedText = findAndReplace(text, replacements);

    console.log("replaceedText", replacedText);
    return replacedText;
  }
  return text;
};

export const parseHtmlIntoPlainText = (text) => {
  const parser = new DOMParser();

  // Parse the Quill-generated HTML
  const doc = parser.parseFromString(text, "text/html");

  // Extract and return the plain text content
  return doc.body.textContent || "";
};
